import api from "../config/api";

export const fetchAllPost = async () => {
  const res = await api.get("/post/");
  return res.data.data;
};

export const fetchPostUserById = (postId) => {
  const res = api.get(`/post/${postId}`);
};
export const fetchPostById = (postId) => {
  const res = api.get(`/post/${postId}`);
};

export const createPost = async (formData) => {
  const res = await api.post(`/post/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updatePost = async (postId, formData) => {
  const res = await api.post(`/post/?id=${postId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deletePost = async (postId) => {
  const res = await api.delete(`/post/?id=${postId}`);
  return res.data;
};
